import React from "react";
import get from "lodash/get";
import { array, bool, object, string } from "prop-types";

import NewsHeadline from "../../atoms/NewsHeadline";
import CardImage from "../../atoms/CardImage";
import StoryMetaData from "../../molecules/StoryMetaData";
import SponsorDetails from "../SponsorDetails";
import Excerpt from "../../atoms/Excerpt";
import Caption from "../../atoms/Caption";

import { getExcerpt } from "../../utils/utils";

import "./leftImageRightNews.m.css";

const LeftImageRightNews = ({
  story,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  widths = [250, 480, 764],
  showExcerpt = false,
  showPublishedAt = true,
  cssStyleName,
  showSubHeading = true,
  Htag,
  showCaption = false,
  showSponsor = true,
  iconEnd = false,
  styles = {},
  className = "",
}) => {
  if (!story) return null;

  const excerpt = showExcerpt ? getExcerpt(story) : "";
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const showLiveBlog = story["story-template"] === "live-blog";
  const sponsor = sponsorId && !showLiveBlog;

  return (
    <div style={styles} className={`left_image_right_news news_item ${className}`} styleName="base">
      <div className="news_item_content">
        <div styleName="left-side-image" className="left-image">
          <CardImage
            className="card-with-image-zoom"
            showStoryTypeIcon={!iconEnd}
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={widths}
            linkEnable={true}
          />
          {showCaption && <Caption story={story} />}
        </div>

        <div className="content-area">
          <NewsHeadline
            showSubHeading={showSubHeading}
            iconEnd={iconEnd}
            Htag={Htag}
            story={story}
            cssStyleName={cssStyleName}
          />
          <Excerpt excerpt={excerpt} url={story.url} />
          {showSponsor && !sponsor && <StoryMetaData story={story} isPublished={showPublishedAt} />}
        </div>
      </div>
      {showSponsor && sponsor && <SponsorDetails sponsorId={sponsorId} showImage={false} />}
    </div>
  );
};

LeftImageRightNews.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  widths: array,
  showExcerpt: bool,
  cssStyleName: string,
  Htag: string,
  showCaption: bool,
  showSponsor: bool,
  iconEnd: bool,
  showSubHeading: bool,
  hideImage: bool,
  styles: object,
  className: string,
  showPublishedAt: bool,
};

export default LeftImageRightNews;
